import { render, staticRenderFns } from "./admin-create-lead-status-cat.vue?vue&type=template&id=d29d3fe4&scoped=true&"
import script from "./admin-create-lead-status-cat.vue?vue&type=script&lang=js&"
export * from "./admin-create-lead-status-cat.vue?vue&type=script&lang=js&"
import style0 from "./admin-create-lead-status-cat.vue?vue&type=style&index=0&id=d29d3fe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29d3fe4",
  null
  
)

export default component.exports